import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  spacing: {
    padding: "1rem 1rem",
  },
  errorContainer: {
    color: theme.palette.grey?.main,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "1rem",
    textAlign: "center",
  },
  receiptContainer: {
    padding: theme.spacing(3),
    width: "fit-content",
    margin: "0 auto",
    justifyContent: "space-between",
  },
  label: {
    textAlign: "left",
    fontFamily: "Roboto",
    fontSize: "1rem",
  },
  value: {
    textAlign: "right",
    fontSize: "1rem",
  },
  cardType: {
    textAlign: "center",
    fontSize: "1rem",
  },
  divider: {
    width: "100%",
    margin: "15px 0",
    height: "2px",
  },
  container: {
    width: "100%",
    maxWidth: 400,
  }
}));
